import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import { firebaseAuth } from './server/init';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about-us',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue'),
    },
    {
      path: '/our-products',
      name: 'products',
      component: () => import('./views/Products.vue'),
    },
    {
      path: '/recipes',
      name: 'recipes',
      component: () => import('./views/Recipes.vue'),
    },
    {
      path: '/where-to-buy',
      name: 'locations',
      component: () => import('./views/Locations.vue'),
    },
    {
      path: '/store',
      name: 'store',
      component: () => import('./views/Store.vue'),
    },
    {
      path: '/store/:category',
      name: 'store-detail-category',
      component: () => import('./views/StoreCatDetail.vue'),
    },
    {
      path: '/store/:category/:subCategory',
      name: 'store-detail-subcategory',
      component: () => import('./views/StoreCatDetail.vue'),
    },
    {
      path: '/store/:category/:subCategory/:filter',
      name: 'store-detail',
      component: () => import('./views/StoreDetail.vue'),
    },
    {
      path: '/store/:category/:subCategory/:filter',
      name: 'store-detail-filter',
      component: () => import('./views/StoreCatDetail.vue'),
    },
    {
      path: '/product-detail/:category/:subCategory/:filter/:product',
      name: 'product-detail',
      component: () => import('./views/ProductDetail.vue'),
    },
    {
      path: '/shopping-cart',
      name: 'cart',
      component: () => import('./views/Cart.vue'),
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import('./views/Checkout.vue'),
    },
    {
      path: '/order-confirmation/:order',
      name: 'order-confirmation',
      component: () => import('./views/OrderConfirmation.vue'),
    },
    {
      path: '/contact-us',
      name: 'contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/admin/:id',
      name: 'admin',
      component: () => import('./views/Admin.vue'),
      children: [
        {
          path: 'store-edit',
          name: 'edit',
          component: () => import('./views/EditStore.vue'),
        },
        {
          path: 'store-new',
          name: 'new',
          component: () => import('./views/NewStore.vue'),
        },
      ],
    },
    {
      path: '/sign-up',
      name: 'signup',
      component: () => import('./components/auth/Signup.vue'),
    },
    {
      path: '/investor-sign-up',
      name: 'investor-signup',
      component: () => import('./components/auth/InvestorSignup.vue'),
    },
    {
      path: '/log-in',
      name: 'login',
      component: () => import('./components/auth/Login.vue'),
    },
    {
      path: '/business-plan',
      name: 'business-plan',
      component: () => import('./views/BusinessPlan.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/terms-of-use',
      name: 'terms',
      component: () => import('./views/Terms.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue'),
    },
  ],
  scrollBehavior(to, from, next) {
    document.body.scrollTo(0, 0);
  },
});


router.beforeEach((to, from, next) => {
  firebaseAuth.onAuthStateChanged((user) => {
  user = firebaseAuth.currentUser;
  if (to.matched.some((rec) => rec.meta.requiresAuth)) {
      if (user) {
        next();
      } else {
        next({
          path: '/log-in',
          query: { redirect: to.fullPath },
        });
      }
    } else {
      next();
    }
  });
});


export default router;
